import { loadable } from '../../common/utils/lazyLoading';
import structure from './structures/menu';
const SiteManagementPage = loadable(() => import('./SiteManagementPage'));
export default {
    id: 'site_management',
    title: 'Site Management',
    icon: 'cog3',
    route: 'site-management',
    defaultRoute: 'site-management/site-list',
    group: 'administration',
    component: SiteManagementPage,
    order: 7,
    structure,
};
